import { writable } from 'svelte/store';
import { createRemovableStore } from './removable';
import { createPersistedStore } from './persisted';
import type { XpGain } from '$lib/types';

interface ToastAction {
  /** Content of the action */
  content: string;
  /** Invoked on click of the action */
  func?: () => void;
  action?: () => void;
}

export interface Toast {
  /** Duration of the toast in milliseconds (default: 3000) */
  duration?: number;
  /** Determines the type of Toast to display */
  kind: 'info' | 'attention' | 'error' | 'success';
  /** Message content of the Toast notification */
  content: string;
  /** Screen placement (default: right) */
  placement?: 'left' | 'right' | 'center';
  /** Actionable buttons within the Toast */
  actions?: ToastAction[];
  /** Function runs when a Toast is closed by the user or when the duration expires */
  onClose?: () => void;
}
export const Toasts = createRemovableStore<Toast>();
export const XpGains = createRemovableStore<XpGain>();

// Dashboard Sidebar
export const dashboardState = writable({
  mobileVisible: false
});
export const dashboardType = writable<string | null>(null);

// Promo codes
export const promoCode = createPersistedStore<string | null>('mfy_promo_code', null);

// Games
export const conversionPageEmail = writable<string | null>(null);

// Uploads
export const uploadStore = writable({});

// Supporters
export const supporterStore = createPersistedStore<{
  id?: string;
  slug?: string;
  name?: string;
  cover?: string;
  avatar?: string;
  exp?: string;
}>('mfy:supporter:ref', {});
